
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import {
  EventDto,
  PageDto,
  ScheduleDto,
  FormFieldDto,
  FormType,
  FormFieldType,
  ListingOptions,
  ReviewStatus,
  InputSelectOption,
} from 'fourwaves-shared';
import { FilterBar, MobileFilterBar, FilterMultiSelect, FilterToggle } from 'fourwaves-shared/components';

@Component({
  components: {
    FilterMultiSelect,
    FilterToggle,
    FilterBar,
    MobileFilterBar,
  },
})
export default class PosterFilterBar extends Vue {
  @Prop({ required: true }) readonly virtualSessions!: ScheduleDto[];
  @Prop({ required: true }) readonly currentEvent!: EventDto;
  @Prop({ required: true }) readonly page!: PageDto | null;
  @Prop({ required: true }) readonly totalCount!: number;
  @Prop({ required: true }) readonly isReviewFilteringAvailable!: boolean;
  @Prop({ type: Boolean, default: false }) readonly areFiltersCollapsed!: boolean;
  @Prop({ type: Boolean, default: false }) readonly firstLoadCompleted!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hasAppliedFilters!: boolean;

  get scheduleOptions(): InputSelectOption[] {
    return this.virtualSessions.map(({ id, title }) => ({ id, label: this.transl8(title) }));
  }

  get additionalFilters(): FormFieldDto[] {
    if (!this.page || !this.page.formFields.length) return [];
    const form = this.currentEvent.forms.find(({ type }) => type === FormType.Submission)!;

    const isCorrectFieldType = ({ fieldType }: FormFieldDto) =>
      fieldType === FormFieldType.Radios ||
      fieldType === FormFieldType.Checkboxes ||
      fieldType === FormFieldType.Dropdown;

    return form.formSections
      .flatMap(({ formFields }) => formFields)
      .filter(field => this.page!.formFields.find(({ id }) => id === field.id) && isCorrectFieldType(field));
  }

  get reviewFilters(): InputSelectOption[] {
    return Object.values(ReviewStatus)
      .map(status => ({
        id: status,
        label: this.$t(`global.review_status.${status}`),
      }))
      .filter(({ id }) => id !== ReviewStatus.Unassigned);
  }

  get hasSorting() {
    return this.listingOptions.length > 0;
  }

  get listingOptions(): ListingOptions[] {
    return [ListingOptions.Alphabetical, ListingOptions.Upvotes];
  }

  public getFilterOptions(field: FormFieldDto): InputSelectOption[] {
    return field.formFieldChoices.map(({ id, shortLabel }) => ({ id, label: this.transl8(shortLabel) }));
  }
}
